import { Observable } from "rxjs";

import * as http from "../../../services/http.service";
import mapParameters from "../../../utils/mapParameters";
import { SearchResults } from "../../../types/search/search-results.interface";

import { defaultParams, paramMap } from "../types/campaign-briefs.config";
import {
  ICampaignBriefsFilterOptions,
  ICampaignBriefsFilters,
  TCampaignBriefResults,
} from "../types/campaign-briefs.interface";

export function fetchBriefs(
  parameters: ICampaignBriefsFilters = {}
): Observable<SearchResults<TCampaignBriefResults>> {
  const queryString = mapParameters({ ...defaultParams, ...parameters }, paramMap);

  return http.get<SearchResults<TCampaignBriefResults>>(`/campaign-briefs/${queryString}`);
}

export function getCampaignBriefFilterOptions(): Observable<ICampaignBriefsFilterOptions> {
  return http.get("/campaign-briefs/filter-options");
}
